import {
  AddDeliveryNote,
  OrderForDeliveryDetails,
  UploadDeliveryLocationImage,
} from '../../../src/driver/types/deliveryDetails';
import {
  RecommendedItemCell,
  ReplacementItemDetails,
  SearchCatalog,
} from '../../../src/itemDetails/types/itemReplacement';

import {BuyersOnMap} from '../../../src/driver/types/mapOverview';
import {GetAccountSetupInfo} from '@buncha/hiring/types/onboardingPhases';
import {OrderForOrderDetails} from '../../../src/driver/types/orderDetails';
import {OrdersForDelivery} from '../../../src/driver/types/driverOrders';
import {ShiftByDate} from '../../../src/openShifts/types/openShifts';

export interface WhenIWorkLoginType {
  isLogin: boolean;
  refreshToken: string;
  inf: {
    email: string;
    password: string;
  };
}

export interface WhenIWorkApiResponse {
  data: {
    user: {
      email?: string;
      first_name?: string;
      last_name?: string;
      phone_number?: string;
      positions?: number[];
    };
  };
}

export interface WhenIWorkData {
  login: WhenIWorkLoginType;
  apiResponse: WhenIWorkApiResponse;
}

export interface GetAvailableShiftsResponse {
  getAvailableShifts: {
    days: ShiftByDate[];
  };
}

export interface TakeShiftResponse {
  takeShift: {
    availableShift: {
      days: ShiftByDate[];
    };
  };
}
// eslint-disable-next-line no-shadow
export enum NetworkConfiguration {
  developement1 = 'developement1',
  developement2 = 'developement2',
  developement3 = 'developement3',
  staging = 'staging',
  qa = 'qa',
  uat = 'uat',
  sandbox = 'sandbox',
  preproduction = 'preproduction',
  production = 'production',
}
export interface AddNotesForOrderItemResponse {
  addNoteForOrderItem: {
    note: string;
  };
}

export interface RecommendItemsForSubstitutesResponse {
  recommendItemsForSubstitutes: {
    items: RecommendedItemCell[];
  };
}

export interface GetOrderItemResponse {
  getOrderItemById: ReplacementItemDetails;
}

export interface SearchCatalogResponse {
  searchCatalog: SearchCatalog;
}

export interface GetOrdersForDeliveryResponse {
  getOrdersForDelivery: OrdersForDelivery[];
}

export interface GetOrderForOrderDetailsResponse {
  getOrder: OrderForOrderDetails;
}

export interface GetOrderForDeliveryDetailsResponse {
  getOrder: OrderForDeliveryDetails;
}
export interface UploadDeliveryLocationImageResponse {
  uploadDeliveryImage: UploadDeliveryLocationImage;
}

export interface AddDeliveryNoteResponse {
  addNoteForDeliveryLocation: AddDeliveryNote;
}

export interface GetBuyersOnMapResponse {
  getOrdersForDelivery: BuyersOnMap[];
}

export interface GetAccountSetupInfoResponse {
  getAccountSetupInfo: GetAccountSetupInfo;
}

// eslint-disable-next-line no-shadow
export enum SessionIdOperation {
  createNew = 'createNewSessionId',
  clearSessionId = 'createSessionId',
}

// eslint-disable-next-line no-shadow
export enum ErrorCategory {
  network = 'network',
  expected = 'expected',
  timeout = 'timeout',
  other = 'other',
}

// eslint-disable-next-line no-shadow
export enum ExpectedErrorClasses {
  EXPECTED_BUSINESS_ERROR = 'EXPECTED_BUSINESS_ERROR',
  UNSERVICE_AREA = 'UNSERVICE_AREA',
  INVALID_DATA = 'INVALID_DATA',
  CODE_NOT_MATCH = 'CODE_NOT_MATCH',
  INVALID_CREATE_USER_TOKEN = 'INVALID_CREATE_USER_TOKEN',
  DATA_LINK_TO_ANOTHER_ACCOUNT = 'DATA_LINK_TO_ANOTHER_ACCOUNT',
}

export interface GraphQLErrorExtension {
  code?: string;
}

export interface GraphQLError {
  extensions?: GraphQLErrorExtension;
}

export interface NetworkError {
  statusCode?: number;
  [key: string]: any;
}

export interface ErrorType {
  networkError?: NetworkError;
  statusCode?: number;
  name?: string;
  message?: string;
  graphQLErrors?: GraphQLError[];
  [key: string]: any;
}

export interface OrderInfo {
  orderId: number;
  organizationId: string;
}

export interface GetBarcodeOrderInfoReq {
  orderInfo: OrderInfo[];
}

export interface GetBarcodesForOrdersResponse {
  getBarcodesForOrders: Barcode[];
}

export interface GenerateBarcodesDataForOrderResponse {
  generateBarcodesDataForOrder: Barcode[];
}

export interface UpdateBarcodeStatusResponse {
  updateBarcodeStatus: Barcode;
}
export interface BarcodeDataItem {
  command: string;
  value: string;
}

export interface Barcode {
  id: number;
  data: BarcodeDataItem[];
}

export interface SetupCMD {
  command: string;
  width: number;
  height: number;
  speed: number;
  density: number;
  sensor: number;
  vertical: number;
  offset: number;
}

export interface BarcodesFile {
  barcodeData: Barcode[];
  cmd: SetupCMD;
  cmdprint: {
    command: string;
    page: number;
    copies: number;
  };
}

export interface GenerateBarcodesFileResponse {
  generateBarcodesFile: BarcodesFile;
}

export interface LoggingDelay {
  mutationDelay: number;
  queryDelay: number;
  networkCheckDelay: number;
  networkCheckTimeout: number;
  enableAllUsers: boolean;
  enabledUsers: number[];
}

export class TimeoutError extends Error {
  delay: boolean;

  constructor(message: string, delay: boolean) {
    super(message);
    this.delay = delay;
  }
}
